import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = ["onUpdate:modelValue", "readonly", "minlength", "maxlength"]
const _hoisted_6 = { class: "input-group-append" }
const _hoisted_7 = ["onClick", "disabled"]
const _hoisted_8 = { class: "error" }
const _hoisted_9 = { class: "error" }
const _hoisted_10 = {
  key: 0,
  class: "form-text text-muted"
}

import { ref, computed, watch, onMounted, toRef } from 'vue'
    import { guid } from '@common/Guid'

    import type { AlternativeEditorAttributeFieldReadModel } from '@Alternatives/Alternatives/Domain/readmodels'
    import type { ValidationError } from '@common/types'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TextInputMultiValue',
  props: {
    propF: {},
    propErrors: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- shortcuts ----------------

    const f = toRef(props, 'propF')
    const errors = toRef(props, 'propErrors')

    // ---------------- local VM ----------------

    class ValueViewModel
    {
        Id: string = guid()
        Value: string | null
        Error: string | null = null

        constructor(value: string | null)
        {
            this.Value = value
        }
    }

    // ---------------- state ----------------

    const values = ref<ValueViewModel[]>([])

    // ---------------- computed ----------------

    const error = computed(() =>
        errors.value?.find(e =>
            e.Context.startsWith(`AlternativeAttribute:${f.value.Id}`)
        )?.Error
    )

    // ---------------- logic ----------------

    function updateReadModel()
    {
        f.value.Values = values.value.map(v => v.Value)
    }

    function addValue()
    {
        values.value.push(new ValueViewModel(null))
    }

    function removeValue(v: ValueViewModel)
    {
        const index = values.value.indexOf(v)
        if (index >= 0)
        {
            values.value.splice(index, 1)
        }
    }

    // ---------------- watchers ----------------

    watch(values, () =>
        {
            updateReadModel()
        },
        { deep: true }
    )

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        values.value = f.value.Values.map(v => new ValueViewModel(v))
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      (f.value.IsRequired)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString(f.value.Name) + " ", 1 /* TEXT */),
      (f.value.IsReadonly === false)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _cache[0] || (_cache[0] = _createTextVNode("(", -1 /* CACHED */)),
            _createElementVNode("a", {
              onClick: addValue,
              class: "text-primary"
            }, "add"),
            _cache[1] || (_cache[1] = _createTextVNode(")", -1 /* CACHED */))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values.value, (v) => {
      return (_openBlock(), _createElementBlock("div", {
        key: v.Id
      }, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Enter text...",
            title: "Please enter text",
            "onUpdate:modelValue": ($event: any) => ((v.Value) = $event),
            readonly: f.value.IsReadonly === true,
            minlength: f.value.MinLength != null ? f.value.MinLength : null,
            maxlength: f.value.MaxLength != null ? f.value.MaxLength : null
          }, null, 8 /* PROPS */, _hoisted_5), [
            [
              _vModelText,
              v.Value,
              void 0,
              { trim: true }
            ]
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: ($event: any) => (removeValue(v)),
              disabled: f.value.IsReadonly === true,
              class: "btn btn-outline-secondary",
              type: "button"
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("span", { class: "fa fa-times" }, null, -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(v.Error), 1 /* TEXT */)
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createElementVNode("div", _hoisted_9, _toDisplayString(error.value), 1 /* TEXT */),
    (f.value.Description)
      ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(f.value.Description), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})